const trackConsentColumns = [
	{ field: 'custId', header: 'Customer ID' },
	{ field: 'consentDescription', header: 'Consent Description' },
	{ field: 'consentPurpose', header: 'Consent Purpose' },
];

export default trackConsentColumns;
